import FinancialInformation from './financialInformation';

export default FinancialInformation;
